angular.module('env.data.rest.modelPool', [])

    .provider('modelPool', function () {
        var defaultConfig = getDefaultConfig();

        function getDefaultConfig() {
            var cfg = new ModelPoolConfigurator();
            // default config
            return cfg;
        }

        /**
         * Helper for ModelPool initialisation
         * @constructor
         */
        function ModelPoolConfigurator() {
            var config = this;
            // todo configurator must have setter methods
        }

        _.extend(this, {
            defaultConfig: defaultConfig
        });

        this.$get = function (ModelPoolService) {

            /**
             * Get new instance of ModelPool with custom config
             * @param {Function} [configFunction] configuration function that takes ModelPoolConfigurator as argument
             * @returns {ModelPoolService}
             */
            function makeAnotherInstance(configFunction) {
                var configurator = _.clone(defaultConfig);
                if (configFunction) {
                    configFunction(configurator);
                }
                return new ModelPoolService(configurator);
            }

            return _.extend(makeAnotherInstance(), {
                makeAnotherInstance: makeAnotherInstance
            });
        };
    })

    .factory('ModelPoolService', function ($q, EventingMixin) {

        /**
         * Model Pool service
         * @param {ModelPoolConfigurator} configurator
         * @constructor
         */
        function ModelPoolService(configurator) {

            var _this = this;
            _.extend(_this, new EventingMixin([
                'modelPromise',
                'modelUpdated',
                'modelRemove',
                'clearCache'
            ]));

            /**
             * Config
             */
            var config = configurator;

            /**
             * Storage of models
             */
            var storage = {};

            /**
             * Storage of promises of models that will be requested from the server but not returned yet
             */
            var promised = {};

            /**
             * Get model's type
             * @param {RepresentationModel} model
             * @returns {string} model's type
             * @private
             */
            function _getType(model) {
                return model.getType();
            }

            /**
             * Get model's id for cache service
             * @param {RepresentationModel} model
             * @returns {string} model's id
             * @private
             */
            function _getId(model) {
                return model.getId();
            }

            /**
             * Put model to the cache
             * @param {RepresentationModel|Array.<RepresentationModel>} model model or array or models to store in the cache
             */
            function put(model) {
                if (_.isArray(model)) {
                    var result = [];
                    _.forEach(model, function (m) {
                        result.push(putModel(m));
                    });
                    return result
                } else {
                    return putModel(model);
                }
            }

            function putModel(model) {
                if (!model) {
                    return;
                }
                var type = _getType(model);
                var id = _getId(model);

                if (!storage[type]) {
                    storage[type] = {};
                }
                if (storage[type][id]) {
                    var toRaiseEvent = false;
                    if (!_.isEqual(storage[type][id].$model, model.$model)) {
                        toRaiseEvent = true;
                    }
                    _resolveConflict(storage[type][id], model);
                    if (toRaiseEvent) {
                        _this.events.raise("modelUpdated", storage[type][id]);
                    }
                } else {
                    storage[type][id] = model;
                }

                return storage[type][id];
            }

            /**
             * Resolve conflicts
             * @param {RepresentationModel} storedModel
             * @param {RepresentationModel} newModel
             * @returns {RepresentationModel} storedModel, with resolved conflicts
             * @private
             */
            function _resolveConflict(storedModel, newModel) {
                // todo: resolve conflicts
                return _.resetObject(storedModel, newModel)
            }

            /**
             * Declare the promise of future RepresentationModel
             * @param {string} type model type
             * @param {Promise} promise Promise of the RepresentationModel
             * @param {string} [id] ID of the model
             * @returns {!Promise} promise of "put resolved model to the cache" action
             */
            function promise(promise, type, id) {
                if (!id) {
                    return promise.then(function (model) {
                        return put(model);
                    });
                }

                _this.events.raise("modelPromise", {id: id, modelType: type});

                if (!promised[type]) {
                    promised[type] = {};
                }

                return promised[type][id] = promise.then(function (model) {
                    if (model) {
                        var newId = _getId(model);
                        var newType = _getType(model);
                        if (newId != id) {
                            return $q.reject(_.str.sprintf(
                                "ID of the resolved model(%s) is not equal to the promised ID(%s)", newId, id));
                        }
                        if (newType != type) {
                            return $q.reject(_.str.sprintf(
                                "Type of the resolved model(%s) is not equal to the promised type(%s)", newType, type));
                        }
                        delete promised[type][id];
                        return put(model);
                    } else {
                        if (storage[type] && storage[type][id]) {
                            delete storage[type][id];
                        }
                        delete promised[type][id];
                        return storage[type][id];
                    }
                });
            }

            /**
             * Get model from cache
             * @param {string} type - model type
             * @param {string} id - model id
             * @returns {!Promise.<RepresentationModel>} promise of RepresentationModel
             */
            function get(type, id) {
                if (promised[type] && promised[type][id] && _.isPromise(promised[type][id])) {
                    return promised[type][id];
                }
                return $q.when(storage[type] ? storage[type][id] : null);
            }

            /**
             * Check if cache has model
             * @param {string} type - model type
             * @param {string} id - model id
             * @returns {boolean}
             */
            function has(type, id) {
                return !!((storage[type] && storage[type][id]) || (promised[type] && promised[type][id]));
            }

            /**
             * Remove model from cache.
             * Only model will be deleted.
             * Promise(if any) will be preserved.
             * @param {string} type - model type
             * @param {string} id - model id
             */
            function remove(type, id) {
                if (storage[type] && storage[type][id]) {
                    delete storage[type][id];
                    _this.events.raise("modelRemove", {id: id, modelType: type});
                }
            }

            /**
             * Clears the cache.
             * Note: Promised values will be preserved and cached after return
             */
            function removeAll() {
                storage = {};
                _this.events.raise("clearCache");
            }

            _.extend(_this, {
                put: put,
                promise: promise,
                get: get,
                has: has,
                remove: remove,
                removeAll: removeAll
            });
        }

        return (ModelPoolService);
    })

;